var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../assets/success.png"),"alt":""}}),_c('h2',[_vm._v("注册成功")]),_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("如有疑问，请返回公众号首页联系客服")]),_c('button',{on:{"click":_vm.colse}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }